import React from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Grid,
} from "@mui/material";
import {
  HelpOutline as HelpIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";
import { colors, borderRadiusPx } from "../../../../../theme";
import { FIVE_SLOT_CONFIG } from "./fiveSlotConfig";

const FiveSlotWorking = () => {
  return (
    <Box sx={{ mt: 4 }}>
      <Accordion
        sx={{
          borderRadius: `${borderRadiusPx.xl} !important`,
          border: `1px solid ${colors.dashboard.cardBorder || "#e2e8f0"}`,
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
          backgroundColor: "#ffffff",
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <HelpIcon sx={{ color: "#2563eb", fontSize: 24 }} />
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 800, color: colors.slate[900] }}
            >
              {`How does ${FIVE_SLOT_CONFIG.name} work?`}
            </Typography>
          </Stack>
        </AccordionSummary>
        <AccordionDetails sx={{ pt: 0, pb: 3, px: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  p: 2.5,
                  bgcolor: "#f8fafc",
                  borderRadius: borderRadiusPx.lg,
                  border: `1px solid ${colors.slate[200]}`,
                  height: "100%",
                  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                  "&:hover": {
                    borderColor: "#93c5fd",
                    boxShadow: "0 4px 12px rgba(37, 99, 235, 0.08)",
                  },
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 800, color: "#2563eb", mb: 0.75 }}
                >
                  1. Set Your BET
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: colors.slate[600], lineHeight: 1.6 }}
                >
                  Choose the amount of BET you want to wager per spin. Supports manual and automatic spin modes.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  p: 2.5,
                  bgcolor: "#f8fafc",
                  borderRadius: borderRadiusPx.lg,
                  border: `1px solid ${colors.slate[200]}`,
                  height: "100%",
                  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                  "&:hover": {
                    borderColor: "#93c5fd",
                    boxShadow: "0 4px 12px rgba(37, 99, 235, 0.08)",
                  },
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 800, color: "#2563eb", mb: 0.75 }}
                >
                  2. Spin 5 Reels
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: colors.slate[600], lineHeight: 1.6 }}
                >
                  Click SPIN to rotate all 5 reels. Reels stop sequentially from left to right with on-chain random verification.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  p: 2.5,
                  bgcolor: "#f8fafc",
                  borderRadius: borderRadiusPx.lg,
                  border: `1px solid ${colors.slate[200]}`,
                  height: "100%",
                  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                  "&:hover": {
                    borderColor: "#93c5fd",
                    boxShadow: "0 4px 12px rgba(37, 99, 235, 0.08)",
                  },
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 800, color: "#2563eb", mb: 0.75 }}
                >
                  3. Win Mini, Major & Mega Jackpots
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: colors.slate[600], lineHeight: 1.6 }}
                >
                  Match symbols left to right on the center payline. Hit 5x Bell for Mini, 5x Diamond for Major, or 5x Crown for Mega Jackpot!
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default FiveSlotWorking;
